import 'flickity/dist/flickity.min.css';

if ( 
	$('.responsive-slider--wrapper').length > 0
	|| $('.case-studies--slider').length > 0
) { 

	const Flickity = require('flickity');
	require('flickity-fade');

	$('.responsive-slider--wrapper').each(function() {

		let _this     = $(this);
		let _id       = $(this).attr('id');
		let _settings = JSON.parse($(this).attr('data-settings'));
		let flkty     = new Flickity( '#'+_id, {
			autoPlay : false,
			pageDots : false,
			wrapAround : true,
			on: {
				ready: function() {
					_this.addClass('is-ready');
				}
			}
		});

		var flktyStatus = document.querySelector('.responsive-slider--status');

		function updateStatus() {
		  var slideNumber = flkty.selectedIndex + 1;
		  flktyStatus.textContent = '0' + slideNumber + '/' + '0' + flkty.slides.length;
		}

		updateStatus();
		flkty.on( 'select', updateStatus );

	});

	$('.case-studies--slider').each(function() {

		let _this     = $(this);
		let _id       = $(this).attr('id');
		let _settings = JSON.parse($(this).attr('data-settings'));
		let flkty     = new Flickity( '#'+_id, {
			autoPlay : false,
			pageDots : false,
			wrapAround : true,
			on: {
				ready: function() {
					_this.addClass('is-ready');
				}
			}
		});

		var flktyStatus = document.querySelector('.case-studies--slider--status');

		function updateStatus() {
		  var slideNumber = flkty.selectedIndex + 1;
		  flktyStatus.textContent = '0' + slideNumber + '/' + '0' + flkty.slides.length;
		}

		updateStatus();
		flkty.on( 'select', updateStatus );

	});

	$('.posts--slider').each(function() {

		let _this     = $(this).attr('id');
		let _settings = JSON.parse($(this).attr('data-settings'));
		let flkty     = new Flickity( '#'+_this, _settings);

		var flktyStatus = document.querySelector('.posts--slider--status');

		function updateStatus() {
		  var slideNumber = flkty.selectedIndex + 1;
		  flktyStatus.textContent = '0' + slideNumber + '/' + '0' + flkty.slides.length;
		}

		updateStatus();
		flkty.on( 'select', updateStatus );

	});
	
}